(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-deal-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tick(el) {
      var target = new Date(el.getAttribute('data-deadline')).getTime();
      if (isNaN(target)) return;
      function upd() {
        var diff = Math.max(0, target - Date.now());
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var map = { days: d, hours: h, mins: m, secs: s };
        for (var k in map) { var n = el.querySelector('[data-cd="' + k + '"]'); if (n) n.textContent = (map[k] < 10 ? '0' : '') + map[k]; }
      }
      upd(); setInterval(upd, 1000);
    }
    document.querySelectorAll('.bb-countdown[data-deadline]').forEach(tick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var burger = document.querySelector('[data-bb-burger]');
    var drawer = document.querySelector('[data-bb-drawer]');
    if (!burger || !drawer) return;
    function open() { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); burger.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
    function close() { drawer.classList.remove('is-open'); burger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; setTimeout(function () { drawer.hidden = true; }, 260); }
    burger.addEventListener('click', open);
    drawer.querySelectorAll('[data-bb-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bb-hero-slides]').forEach(function (box) {
      var slides = box.querySelectorAll('.bb-hero__slide');
      if (slides.length < 2) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, 3200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-scratch"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-bb-scratch]');
    if (!root) return;
    var KEY = 'bb_scratch_seen_v1';
    var card = root.querySelector('.bb-scratch__card');
    var canvas = root.querySelector('[data-bb-scratch-canvas]');
    var claim = root.querySelector('[data-bb-scratch-claim]');
    var posted = root.getAttribute('data-bb-posted') === 'true';

    function open() {
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); setupCanvas(); });
      document.body.style.overflow = 'hidden';
    }
    function close() {
      root.classList.remove('is-open');
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      document.body.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 250);
    }
    root.querySelectorAll('[data-bb-scratch-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });

    function reveal() {
      root.classList.add('is-revealed');
      if (claim) { claim.disabled = false; }
    }

    function setupCanvas() {
      if (!canvas || canvas.dataset.ready) return;
      var rect = canvas.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      canvas.width = rect.width * dpr; canvas.height = rect.height * dpr;
      var ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      var g = ctx.createLinearGradient(0, 0, rect.width, rect.height);
      g.addColorStop(0, '#9aa0a6'); g.addColorStop(1, '#c8ccd0');
      ctx.fillStyle = g; ctx.fillRect(0, 0, rect.width, rect.height);
      ctx.globalCompositeOperation = 'destination-out';
      var drawing = false, done = false;
      function pos(e) { var r = canvas.getBoundingClientRect(); var t = e.touches ? e.touches[0] : e; return { x: t.clientX - r.left, y: t.clientY - r.top }; }
      function scratch(e) {
        if (!drawing || done) return;
        var p = pos(e);
        ctx.beginPath(); ctx.arc(p.x, p.y, 18, 0, Math.PI * 2); ctx.fill();
        if (Math.random() < 0.12) check();
      }
      function check() {
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var clear = 0; for (var i = 3; i < data.length; i += 4 * 24) { if (data[i] === 0) clear++; }
        if (clear / (data.length / (4 * 24)) > 0.5) { done = true; reveal(); }
      }
      canvas.addEventListener('pointerdown', function (e) { drawing = true; root.classList.add('is-scratching'); scratch(e); });
      canvas.addEventListener('pointermove', scratch);
      window.addEventListener('pointerup', function () { drawing = false; if (!done) check(); });
      canvas.dataset.ready = '1';
    }

    if (posted) { open(); reveal(); return; }
    var seen; try { seen = localStorage.getItem(KEY); } catch (e) {}
    // re-show to returning visitors after a cooldown (legacy '1' value re-shows immediately)
    var cooldownDays = parseInt(root.getAttribute('data-cooldown'), 10); if (isNaN(cooldownDays)) cooldownDays = 3;
    if (seen && (Date.now() - parseInt(seen, 10)) < cooldownDays * 86400000) return;
    var delay = (parseInt(root.getAttribute('data-delay'), 10) || 6) * 1000;
    setTimeout(open, delay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-sound-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // sample grid: one player at a time
    document.querySelectorAll('[data-bb-snd]').forEach(function (grid) {
      var items = grid.querySelectorAll('.bb-snd__item');
      items.forEach(function (item) {
        var btn = item.querySelector('[data-bb-snd-play]');
        var audio = item.querySelector('audio');
        if (!btn || !audio) return;
        btn.addEventListener('click', function () {
          if (audio.paused) {
            items.forEach(function (o) { var a = o.querySelector('audio'); if (a && a !== audio) { a.pause(); a.currentTime = 0; o.classList.remove('is-playing'); } });
            audio.play(); item.classList.add('is-playing');
          } else { audio.pause(); audio.currentTime = 0; item.classList.remove('is-playing'); }
        });
        audio.addEventListener('ended', function () { audio.currentTime = 0; item.classList.remove('is-playing'); });
      });
    });
    // A/B compare
    document.querySelectorAll('[data-bb-ab]').forEach(function (ab) {
      var playBtn = ab.querySelector('[data-bb-ab-play]');
      var before = ab.querySelector('[data-bb-ab-before]');
      var after = ab.querySelector('[data-bb-ab-after]');
      var iconPlay = ab.querySelector('.bb-ab__icon-play');
      var iconPause = ab.querySelector('.bb-ab__icon-pause');
      var mode = 'before';
      function active() { return mode === 'before' ? before : after; }
      function other() { return mode === 'before' ? after : before; }
      function setPlaying(p) { if (iconPlay) iconPlay.hidden = p; if (iconPause) iconPause.hidden = !p; ab.classList.toggle('is-playing', p); }
      ab.querySelectorAll('[data-bb-ab-mode]').forEach(function (m) {
        m.addEventListener('click', function () {
          ab.querySelectorAll('[data-bb-ab-mode]').forEach(function (x) { x.classList.remove('is-active'); });
          m.classList.add('is-active');
          var wasPlaying = !active().paused;
          var t = active().currentTime;
          active().pause();
          mode = m.getAttribute('data-bb-ab-mode');
          active().currentTime = t || 0;
          if (wasPlaying) active().play();
        });
      });
      if (playBtn) playBtn.addEventListener('click', function () {
        if (active().paused) { other().pause(); other().currentTime = 0; active().play(); setPlaying(true); }
        else { active().pause(); active().currentTime = 0; setPlaying(false); }
      });
      [before, after].forEach(function (a) { if (a) a.addEventListener('ended', function () { a.currentTime = 0; setPlaying(false); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bb-ugc-phone"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    document.querySelectorAll('[data-bb-ugc-row]').forEach(function (row) {
      var section = row.closest('.shopify-section') || document;
      var segs = Array.prototype.slice.call(section.querySelectorAll('.bb-ugc__seg'));
      var originals = Array.prototype.slice.call(row.querySelectorAll('.bb-ugc__cell'));
      var n = originals.length;
      if (!n) return;
      var cells = originals, looped = false, current = 0;

      function buildLoop() {
        if (looped || n < 2) return;
        function clones() {
          return originals.map(function (c) {
            var k = c.cloneNode(true);
            k.classList.add('bb-ugc__clone');
            k.setAttribute('aria-hidden', 'true');
            k.setAttribute('tabindex', '-1');
            return k;
          });
        }
        clones().forEach(function (c) { row.insertBefore(c, originals[0]); });
        clones().forEach(function (c) { row.appendChild(c); });
        cells = Array.prototype.slice.call(row.querySelectorAll('.bb-ugc__cell'));
        looped = true;
      }

      function teardown() {
        if (!looped) return;
        Array.prototype.slice.call(row.querySelectorAll('.bb-ugc__clone')).forEach(function (c) { c.remove(); });
        cells = originals; looped = false; row.scrollLeft = 0;
        originals.forEach(function (x) { x.classList.remove('is-active'); });
        segs.forEach(function (s, i) { s.classList.toggle('is-active', i === 0); });
      }

      function centerOriginal(i) {
        var t = originals[i];
        row.scrollLeft = t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2;
      }

      function centeredCell() {
        var mid = row.scrollLeft + row.clientWidth / 2, best = cells[0], bd = Infinity;
        cells.forEach(function (c) {
          var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid);
          if (d < bd) { bd = d; best = c; }
        });
        return best;
      }

      function realIndex(cell) {
        var p = Array.prototype.slice.call(row.children).indexOf(cell);
        return ((p % n) + n) % n;
      }

      var wrapT;
      function refresh() {
        var c = centeredCell();
        cells.forEach(function (x) { x.classList.toggle('is-active', x === c); });
        current = realIndex(c);
        segs.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        if (looped) {
          clearTimeout(wrapT);
          wrapT = setTimeout(function () {
            var cc = centeredCell();
            if (originals.indexOf(cc) === -1) centerOriginal(realIndex(cc));
          }, 110);
        }
      }

      var raf;
      row.addEventListener('scroll', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(refresh); }, { passive: true });
      window.addEventListener('resize', function () { if (looped) centerOriginal(current); });

      function start() {
        if (mq.matches) { if (!looped) { buildLoop(); centerOriginal(0); } refresh(); }
        else { teardown(); refresh(); }
      }
      if (mq.addEventListener) mq.addEventListener('change', start);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
